import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core/styles'
import UploadIcon from '../../src/assets/images/icons/upload.svg'
import CustomImage from './CustomImage'
import { GiDivert } from 'react-icons/gi'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import CustomButton from './CustomButton'

import S3 from 'react-aws-s3'
import { handleFile, loadingAndText } from '../shared/constants'
import Loader from './Loader'
import { CSVLink } from 'react-csv'
import { useBulkUpload } from '../hooks/Download/useBulkUpload'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  hover: {
    cursor: 'pointer',
  },
}))

export default function CustomUpload({ className, heading, headers, tempHeaderData = [], tempHeaders, sampleName, sheetName, bulkUpload, setFileTemp, redirectUrl, addData }) {
  const [file, setFile] = useState('')
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)
  const { BulkUpload, loading } = useBulkUpload(redirectUrl, addData)
  console.log({ sampleName, tempHeaders })
  const [fileName, setFileName] = useState('')
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const bulkUploadData = () => {
    if (bulkUpload) {
      bulkUpload()
    } else {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('sheetName', sheetName)
      BulkUpload(formData)
      setFile('')
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  const csvReport = {
    data: tempHeaderData,
    headers: tempHeaders ? tempHeaders : headers,
    filename: sampleName
      ? `${sampleName}.csv`
      : heading === 'Manage Products'
      ? 'sample_product.csv'
      : heading === 'Manage Targets'
      ? 'target.csv'
      : heading === 'Manage Regions'
      ? 'sample_region.csv'
      : heading === 'Manage Zone'
      ? 'sample_zone.csv'
      : heading === 'Manage State'
      ? 'sample_state.csv'
      : heading === 'Manage District'
      ? 'sample_district.csv'
      : heading === 'Manage City'
      ? 'sample_city.csv'
      : heading === 'Manage Categories'
      ? 'sample_category.csv'
      : heading === 'Manage SubCategory'
      ? 'sample_subcategory.csv'
      : heading === 'Manage Area'
      ? 'sample_area.csv'
      : heading === 'Manage Store'
      ? 'sample_store.csv'
      : heading === 'Manage Employees'
      ? 'sample_employee.csv'
      : heading === 'Manage Primary Sales'
      ? 'sample_primary_sales.csv'
      : heading === 'Manage Sales Return'
      ? 'sample_sales_return.csv'
      : heading === 'Incentive'
      ? 'sample_incentive.csv'
      : null,
  }

  return (
    <div style={{ zIndex: 100 }}>
      <div ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" onClick={handleToggle} className={className} style={{ marginTop: '14px' }}>
        <CustomImage image={UploadIcon} />
      </div>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'left bottom' }}>
            <Paper style={{ padding: '10px', marginTop: '5px' }}>
              <Typography style={{ fontWeight: 600, textAlign: 'center' }}>Upload</Typography>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  <MenuItem onClick={handleClose}>
                    {tempHeaders ? (
                      <CSVLink {...csvReport} style={{ textDecoration: 'none', color: 'black', fontWeight: 400, fontSize: '14px' }}>
                        Download CSV Sample
                      </CSVLink>
                    ) : (
                      <Typography style={{ fontWeight: 400, fontSize: '14px' }}>Download CSV Sample</Typography>
                    )}
                  </MenuItem>
                  <MenuItem>
                    <input
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      style={{ display: 'none' }}
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={(e) => {
                        setFileTemp ? setFileTemp(e.target.files[0]) : setFile(e.target.files[0])
                        setFileName(e.target.files[0] ? e.target.files[0].name : '')
                      }}
                    />
                    <label htmlFor="contained-button-file">
                      <Box display="flex">
                        <AttachFileIcon style={{ marginRight: '5px' }} />
                        <Typography style={{ fontWeight: 400, fontSize: '14px' }}>
                          <Box display="flex">
                            {fileName ? fileName : 'Select a CSV/XLSX File'}
                            {/* {progress ? (
                              <CircularProgress style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
                            ) : null} */}
                          </Box>
                        </Typography>
                      </Box>
                    </label>
                  </MenuItem>
                  <div style={{ margin: '10px 0px 6px 15px' }}>
                    <CustomButton
                      text={loadingAndText(loading, 'Upload')}
                      // disabled={fileName ? false : true}
                      handleSubmit={() => {
                        bulkUploadData()
                        setFileName('')
                      }}
                    />
                  </div>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
